import React, { useState, useEffect } from "react";

import icons from "./icons";
import Button from "../../../blocks/Button";
import SRS from "../../../../../services/StudentRecordService";
import Loading from "../../Loading";
import { useTranslation } from "react-i18next";

const TrackingModal = ({ student, closeModal }) => {
    const { 
      studentId,
      first_name, 
      last_name, 
      practiceMinutes, 
      tutoringMinutes,
      storyCount,
      incompleteStoryCount
    } = student;

    const [isLoading, setIsLoading] = useState(true);
    const [isEnglish, setIsEnglish] = useState(false);
    const [isSpanish, setIsSpanish] = useState(false);

    const {t} = useTranslation("tracking_report");

    useEffect(() => {
      getStudentData()
    }, [])

    const getStudentData = async () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const day = today.getDay();
      const diff = today.getDate() - day + (day == 0 ? -6 : 1);
      const startDate = new Date(today.setDate(diff));
      const studentActivities = await SRS.studentActivities(studentId, 100, ["assessment","tutor"], ["scored","rescored"], false, startDate);
      studentActivities.forEach((activity) => (activity.tags.includes("ES_MX") ? setIsSpanish(true) : setIsEnglish(true)));
      setIsLoading(false)
    }

    return (
      <div className="trackingModalContainer">
        <div className="trackingModal">
          {isLoading ? 
            <Loading /> :
            <React.Fragment>
              <div className="trackingModalHeader">
                <div>{first_name} {last_name}</div>
                <div className="tracking-language-icon-modal-container">
                  {isEnglish && <img src={icons.english} className="tracking-language-icon-modal" />}
                  {isSpanish && <img src={icons.spanish} className="tracking-language-icon-modal" />}
                </div>
                <div>{t("Activity This Week")}</div>
              </div>
              <div className="trackingModalContents">
                <TrackingModalRow fieldName="Minutes Reading" fieldValue={practiceMinutes} isTime={true}/>
                <TrackingModalRow fieldName="Tutoring Time" fieldValue={tutoringMinutes} isTime={true}/>
                <TrackingModalRow fieldName="Completed Stories" fieldValue={storyCount}/>
                <TrackingModalRow fieldName="Incomplete Stories" fieldValue={incompleteStoryCount}/>
              </div>
              <div className="next-button-container">
                <Button onClick={closeModal} style={{marginRight: 0}}>{t("common:Close")}</Button>
              </div>
            </React.Fragment>
          }
        </div>
        <div className="trackingModalBackground" onClick={closeModal}/>
      </div>
    )
  }
  
  const TrackingModalRow = ({fieldName, fieldValue, isTime=false}) => {
    const {t} = useTranslation("tracking_report");
    let minText = "";
    if (isTime) minText = t("minute", {count: fieldValue});
    return (
      <div className="trackingModalRow">
        <div className="trackingModalColumn">{t(fieldName)}</div>
        <div className="trackingModalColumn">{fieldValue <= 0 && isTime ? t("Less than 1 minute") : `${fieldValue} ${minText}`}</div>
      </div>
    )
  }

export default TrackingModal;